<div *ngIf="show$ | async" class="notification">
  <div class="notification__content">
    <i *ngIf="showProgressSpinner" class="notification__spinner"></i>
    <div class="notification__message">{{ message$ | async }}</div>
  </div>
</div>
